(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rydr-adventure"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rydr-ad-scroll-handler')) {
  customElements.define('rydr-ad-scroll-handler', class extends HTMLElement {});
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ad-scroll]');
    if (!button) return;
    const strip = button.closest('.rydr-adventure').querySelector('[data-ad-strip]');
    if (strip) strip.scrollBy({left: Number(button.dataset.adScroll) * Math.min(340, strip.clientWidth * .8), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
  });
}

  } catch(e) { console.error(e); }
})();
})();
